import {
  UPDATECUSTOMERDETAILS_SUCCESS,
  UPDATECUSTOMERDETAILS_FAILED,
  RESET_UPDATECUSTOMERDETAILS,
  LOADING_UPDATECUSTOMERDETAILS,
  NETWORK_ERROR_UPDATECUSTOMERDETAILS,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetUpdateCustomerDetails = () => {
  return { type: RESET_UPDATECUSTOMERDETAILS };
};

const updateCustomerDetails = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_UPDATECUSTOMERDETAILS });
  await partnerServices
    .post("updateCustomerDetails", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(updateCustomerDetailssuccess(res.data));
          break;
        default:
          dispatch(updateCustomerDetailsFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_UPDATECUSTOMERDETAILS, payload: err });
    });
};
function updateCustomerDetailssuccess(data) {
  return {
    type: UPDATECUSTOMERDETAILS_SUCCESS,
    payload: data,
  };
}
function updateCustomerDetailsFailed(data) {
  return {
    type: UPDATECUSTOMERDETAILS_FAILED,
    payload: data,
  };
}

export { resetUpdateCustomerDetails, updateCustomerDetails };
